import {Inject, Pipe, PipeTransform} from '@angular/core';
import * as _ from "lodash";
import {TranslateService} from "@ngx-translate/core";

const UNLIMITED = 'UNLIMITED';

@Pipe({
  standalone: false,
  name: 'capacityTooltipPipe'
})
export class CapacityTooltipPipe implements PipeTransform {
  constructor(@Inject(TranslateService) private translateService: TranslateService) {}

  transform(value: { current: number; max: number }, unit?: string, fixed: number = 2): string {
    const ratio = (value.current / value.max) * 100;
    const unitSuffix = unit ? ` ${this.translateService.instant(unit)}` : '';
    const displayCurrent = Number.isSafeInteger(value.current) ? value.current : value.current.toFixed(fixed);

    if (!value.max) {
      return `${displayCurrent}${unitSuffix} / ${this.translateService.instant(UNLIMITED)}`;
    }

    const displayMax = Number.isSafeInteger(value.max) ? value.max : value.max.toFixed(fixed);
    const displayRatio = Number.isSafeInteger(ratio) ? ratio : ratio.toFixed(fixed);

    return `${displayCurrent}${unitSuffix} / ${displayMax}${unitSuffix} = ${displayRatio}%`;
  }
}
